module.exports = __webpack_public_path__ + "img/rotatecircle.0566f262.png";